import { FC } from 'react';
import { useGetMailingPlaceholders } from '@Hooks/Mailing';
import { EnumMailingSettingGroup } from '@Model';
import { LoadingFrame } from '@synqo/frontend-component-library';
import { Placeholders } from '@Components/Placeholders';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';

export const EmailSettingPlaceholders: FC<{ settingGroup: EnumMailingSettingGroup }> = ({
    settingGroup: settingName,
}) => {
    const canReadEmails = useHasPermission()(Permission.MailingEmailsRead);
    const { placeholders, isLoading } = useGetMailingPlaceholders(settingName, canReadEmails);

    if (!canReadEmails) {
        return null;
    }

    if (isLoading) {
        return <LoadingFrame />;
    }

    return <Placeholders placeholders={placeholders} />;
};
